import React, { useState } from 'react';
import GamesSelectorToggle from './GamesSelectorToggle';
import GamesList from './GamesList';
import GamesPerformanceTable from './GamesPerformanceTable';

export default function Games() {
  const [selectedView, setSelectedView] = useState('games');

  return (
    <main className="games-page">
      <h1 className="page-title">Game Summaries</h1>
      <GamesSelectorToggle selectedView={selectedView} onSelect={setSelectedView} />
      {selectedView === 'games' && <GamesList />}
      {selectedView === 'performances' && <GamesPerformanceTable />}
    </main>
  );
}
